export enum DocumentUploadStatus {
  Uploading = 'Uploading',
  Uploaded = 'Uploaded',
  Deleting = 'Deleting',
  Error = 'Error',
}
